import {
  getLinkWithNextParam,
  handleRedirectionWithSignupSource,
} from '@common/utils'
import { NAVBAR_LINKS } from '@lib/constants/common'
import { Trans } from '@lingui/macro'
import dynamic from 'next/dynamic'
import Link from 'next/link'
import { useRouter } from 'next/router'

const NavbarNewLink = dynamic(() =>
  import('@components/common/navbar-new-link')
)
const LanguageSwitcher = dynamic(() =>
  import('@components/common/language-switcher')
)
const CoursesDropdown = dynamic(() =>
  import('@components/common/navbar/navbar-dropdowns/courses-dropdown')
)
const CampsDropdown = dynamic(() =>
  import('@components/common/navbar/navbar-dropdowns/camps-dropdown')
)

const {
  LOGIN,
  REGISTER,
  JOIN_CLASS_LOGGED_OUT,
  QUIZZES,
  COMPETITIONS,
  BLOG,
  HOME,
} = NAVBAR_LINKS

type Props = {
  isQuizChampionship?: boolean
  hideMobileMenu?: () => void
  customCTAText: string
  customCTAonClick: () => void
  nextPage: string
  tryFreeClassLink?: string
}

const LoggedOutMobileItems = ({
  isQuizChampionship,
  hideMobileMenu,
  customCTAText,
  customCTAonClick,
  nextPage,
  tryFreeClassLink,
}: Props) => {
  const router = useRouter()

  return (
    <nav className="flex-1 min-h-0 flex flex-col">
      <div className="flex-1 min-h-0 overflow-y-auto flex flex-col px-10 pb-5 space-y-5">
        <Link href={HOME.link} prefetch={false}>
          <a className="text-xl text-grey font-500" onClick={hideMobileMenu}>
            <Trans id={HOME.text?.id} values={HOME.text?.values} />
          </a>
        </Link>

        <CoursesDropdown />
        <CampsDropdown />

        <Link href={COMPETITIONS.link} prefetch={false}>
          <a className="text-xl text-grey font-500" onClick={hideMobileMenu}>
            <Trans
              id={COMPETITIONS.text?.id}
              values={COMPETITIONS.text?.values}
            />
          </a>
        </Link>
        {isQuizChampionship && (
          <NavbarNewLink
            link={QUIZZES.link}
            text={QUIZZES.text}
            hideMobileMenu={hideMobileMenu}
          />
        )}

        <a
          className="mt-3 text-xl text-grey font-500"
          target="_blank"
          rel="noopener noreferrer"
          href={BLOG.link}
        >
          <Trans id={BLOG.text?.id} values={BLOG.text?.values} />
        </a>

        {!customCTAText && (
          <>
            <LanguageSwitcher />
            <button
              className="text-xl text-left text-grey font-500"
              onClick={() =>
                handleRedirectionWithSignupSource(
                  router.asPath,
                  getLinkWithNextParam(LOGIN.link, nextPage)
                )
              }
            >
              <Trans id={LOGIN.text?.id} values={LOGIN.text?.values} />
            </button>
          </>
        )}
      </div>

      <div className="flex flex-col px-10 pb-10">
        <hr className="mb-3 text-grey-500" />
        {customCTAText ? (
          <button
            onClick={customCTAonClick}
            className="px-5 py-2 mt-4 text-lg text-center btn btn-orange sm:px-10"
          >
            {customCTAText}
          </button>
        ) : (
          <>
            <button
              onClick={() =>
                handleRedirectionWithSignupSource(
                  router.asPath,
                  tryFreeClassLink ||
                    getLinkWithNextParam(REGISTER.link, nextPage)
                )
              }
              className="px-5 py-2 mt-5 text-lg text-center bg-white btn btn-orange text-orange sm:px-10"
            >
              <Trans id={REGISTER.text?.id} values={REGISTER.text?.values} />
            </button>
            <button
              onClick={() => {
                handleRedirectionWithSignupSource(
                  router.asPath,
                  getLinkWithNextParam(
                    JOIN_CLASS_LOGGED_OUT.link,
                    JOIN_CLASS_LOGGED_OUT.next
                  )
                )
              }}
              className="px-5 py-2 mt-4 text-lg text-center btn btn-orange sm:px-10"
            >
              <Trans
                id={JOIN_CLASS_LOGGED_OUT.text?.id}
                values={JOIN_CLASS_LOGGED_OUT.text?.values}
              />
            </button>
          </>
        )}
      </div>
    </nav>
  )
}
export default LoggedOutMobileItems
